/** Platforms requested when generating multi-format drafts (E1-T3). */
export const GENERATE_PLATFORMS = ['linkedin', 'twitter', 'instagram'] as const;

export type GeneratePlatform = (typeof GENERATE_PLATFORMS)[number];

export const PLATFORM_LABELS: Record<string, string> = {
  linkedin: 'LinkedIn',
  twitter: 'X',
  instagram: 'Instagram',
};

export function getPlatformLabel(platform: string): string {
  return PLATFORM_LABELS[platform] ?? platform;
}
